import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import SectionHeading from "@/components/feature/SectionHeading";

interface LatestNewsProps {
  items: Movie[];
}

export default function LatestNews({ items }: LatestNewsProps) {
  if (items.length === 0) {
    return (
      <div className="py-16 text-center text-foreground-500 text-sm">
        <i className="ri-inbox-line text-4xl block mb-3 text-background-400"></i>
        暂无最新内容，敬请期待
      </div>
    );
  }

  return (
    <section data-product-shop>
      <SectionHeading
        title="最新影视资讯"
        subtitle="按更新时间排序，第一时间了解影视动态"
        moreTo="/category/movie"
        moreLabel="更多资讯"
      />
      <div className="bg-background-50 rounded-lg border border-background-200 divide-y divide-background-200 overflow-hidden">
        {items.map((movie) => (
          <Link
            key={movie.id}
            to={`/detail/${movie.id}`}
            className="group flex gap-4 p-3 md:p-4 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <div className="w-[84px] h-[120px] md:w-[104px] md:h-[148px] shrink-0 rounded-md overflow-hidden bg-background-100">
              <img
                src={movie.cover}
                alt={`${movie.title} 资讯封面`}
                title={`${movie.title} - 剧情介绍`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex-1 min-w-0 py-1">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-[11px] font-medium">
                  {movie.type === "movie" ? "电影" : "电视剧"}
                </span>
                {movie.genres.slice(0, 2).map((g) => (
                  <span
                    key={g}
                    className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-[11px] font-medium"
                  >
                    {g}
                  </span>
                ))}
              </div>
              <h3 className="mt-2.5 font-heading font-bold text-base md:text-lg text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                {movie.title}
              </h3>
              <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {movie.synopsis}
              </p>
              <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  {movie.updatedAt}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500"></i>
                  {movie.rating.toFixed(1)}
                </span>
                <span className="hidden sm:flex items-center gap-1">
                  <i className="ri-map-pin-line"></i>
                  {movie.region}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}